/**
 * Concatenate class names.
 * @param classNames List of CSS classes to concatenate.
 * @return Space-delimited HTML class attribute value.
 */
export const joinClassNames = (classNames: string[]): string =>
    classNames
        .filter((className: string) => className)
        .join(" ")
        .trim();
